window.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);

if (params.get('contact_posted') === 'true') {
  const elements = document.querySelectorAll(
    '#QuoteForm, .x-variant-picker, .x-block-custom-options, .x-block-buy-buttons'
  );

  elements.forEach(el => {
    el.style.visibility = 'hidden';
  });

  setTimeout(() => {
    elements.forEach(el => {
      el.style.display = 'none';
    });

    const successEl = document.querySelector('.custom-product-template');

    if (successEl) {
      successEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

  }, 500);
}
  else{
    const form = document.querySelector('.custom-form-success');
    if (form) {
        form.style.display = 'none';
    }
  }
    // const getEl = document.querySelector('[data-product-id]');
    // const productId = getEl?.getAttribute('data-product-id');
    const selected_opt_8 = document.querySelector('input[name^="Oven Size"]:checked');
    let deliveryPrice = 0;

    if (selected_opt_8.value.trim() === "Napoli 80") {
      deliveryPrice = 880.00;
    } 
    else if (selected_opt_8.value.trim() === 'Napoli 100') {
      deliveryPrice = 1200.00;
    } 
    else if (selected_opt_8.value.trim() === 'Colosso 80') {
      deliveryPrice_text = 1200.00;
    } 
    else if (selected_opt_8.value.trim() === 'Colosso 100') {
      deliveryPrice_text = 1600.00;
    } 
    else if (selected_opt_8.value.trim() === 'Colosso 120') {
      deliveryPrice_text = 1850.00;
    } 
    // else if (productId === '8716959449259') {
    //   deliveryPrice = 1600.00;
    // } 
    // else if (productId === '8725495251115') {
    //   deliveryPrice = 1850.00;
    // } 
    // else if (productId === '8715797299371') {
    //   deliveryPrice = 630.00;
    // } 
    // else if (productId === '8717379862699') {
    //   deliveryPrice = 730.00;
    // }

    // Format price properly
    // console.log(deliveryPrice);
    const formattedPrice_delivery = deliveryPrice.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });

    // Update radios safely
    document.querySelectorAll('input[name="Delivery"]').forEach(radio => {
      if (radio.value.includes('Shipping (contiguous U.S.)')) {
        
        const formattedPrice_delivery = deliveryPrice.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });

        const newText = `Shipping (contiguous U.S.) — ${formattedPrice_delivery}`;

        // Update input value (for form submission)
        radio.value = newText;

        // Update label text (for UI)
        const label = document.querySelector(`label[for="${radio.id}"]`);
        if (label) {
          label.textContent = newText;
        }
      }
    });

      
});


const requiredFields = document.querySelectorAll('[required]');

function validateRequiredField(field) {
  const value = field.value.trim();
  if (!value) {
    field.classList.add('custom-field-error');
    return false; // Field is invalid
  } else {
    field.classList.remove('custom-field-error');
    return true; // Field is valid
  }
}

requiredFields.forEach(field => {
  field.addEventListener('blur', () => validateRequiredField(field));

  field.addEventListener('input', () => {
    if (field.value.trim()) {
      field.classList.remove('custom-field-error');
    }
  });
});

const originalFetch = window.fetch;

// window.fetch = function (...args) {
//   if (typeof args[0] === 'string' && args[0].includes('/cart/add')) {
    
//     // --- 1. FORCE VALIDATION ---
//     // We check all fields now, otherwise 'errorFields' might be empty 
//     // if the user never touched the inputs.
//     requiredFields.forEach(field => validateRequiredField(field));

//     // --- 2. CHECK FOR ERRORS ---
//     const errorFields = document.querySelectorAll('.custom-field-error');
    
//     if (errorFields.length > 0) {
//       // SCROLL TO FIRST ERROR
//       const first = errorFields[0];
//       const yOffset = -120; // Extra padding so the field isn't tucked under a header
//       const y = first.getBoundingClientRect().top + window.pageYOffset + yOffset;

//       window.scrollTo({
//         top: y,
//         behavior: 'smooth'
//       });

//       first.focus(); // Focus the field so user can type immediately
//       return Promise.reject('Blocked add to cart: Missing required fields');
//     }

//     // --- 4. FINAL SUBMISSION ---
//     document.querySelector('#product-form-template--21425500291243__main')?.submit();
//     return Promise.reject('Redirecting to Quote Form');
//   }

//   return originalFetch.apply(this, args);
// };



// const hiddenInput_1 = document.getElementById('ContactFormColor');
// const hiddenInput_2 = document.getElementById('ContactFormStand');
// const hiddenInput_3 = document.getElementById('ContactFormChimney');
// const hiddenInput_4 = document.getElementById('ContactFormFuelType');
// const hiddenInput_5 = document.getElementById('ContactFormPrice');
// const hiddenInput_6 = document.getElementById('ContactFormPizza');
// const hiddenInput_7 = document.getElementById('ContactFormDelivery');
// const hiddenInput_8 = document.getElementById('ContactFormVariant');

function syncColor() {
  const selected_opt_1 = document.querySelector('input[name^="Color-1"]:checked');
  const selected_opt_2 = document.querySelector('input[name^="Heavy Duty Steel Stand-2"]:checked');
  const selected_opt_3 = document.querySelector('input[name^="Stainless Steel Double Wall Chimney with Cup-3"]:checked');
  const selected_opt_4 = document.querySelector('input[name^="Fuel Type"]:checked');
  const selected_opt_5 = document.querySelector('.main-product-price .price');
  const selected_opt_6 = document.querySelector('input[name^="Pizza Peel"]:checked');
  const selected_opt_7 = document.querySelector('input[name^="Delivery"]:checked');
  const selected_opt_8 = document.querySelector('input[name^="Oven Size"]:checked');
  // const selected_opt_8 = document.querySelector('select[name*="properties[Oven Size]"]').value;

//   if (selected_opt_1) hiddenInput_1.value = selected_opt_1.value;
  if (selected_opt_2) {
    let value = selected_opt_2.value;

    if (value === "Black Heavy Duty Stand") {
      value = "Yes, We Want Black Heavy Duty Stand";
    }

    // hiddenInput_2.value = value;
    }
    // if (selected_opt_3) hiddenInput_3.value = selected_opt_3.value;
    // if (selected_opt_4) hiddenInput_4.value = selected_opt_4.value;

      let pizzaPeelPrice = 0;
      let deliveryPrice = 0;
      let basePrice = 0;
      if (selected_opt_8 === "Napoli 80") {
        basePrice = 12900;
      }
      else if (selected_opt_8 === "Napoli 100") {
        basePrice = 14900;
      }
      else if (selected_opt_8 === "Colosso 80"){
        basePrice = 18200;
      }
      else if (selected_opt_8 === "Colosso 100"){
        basePrice = 20200;
      }
      else if (selected_opt_8 === "Colosso 120"){
        basePrice = 23500;
      }
      if (selected_opt_6) {
    //   hiddenInput_6.value = selected_opt_6.value;
        const value = selected_opt_6.value;

        // Extract number after $
        const match = value.match(/\$(\d+(?:\.\d+)?)/);

        if (match) {
          pizzaPeelPrice = parseFloat(match[1]);
        }
      }
      if (selected_opt_7) {
    //   hiddenInput_7.value = selected_opt_7.value;
        const value = selected_opt_7.value;
        // Extract number after $
        const match = value.match(/\$(\d+(?:\.\d+)?)/);
        if (match) {
          deliveryPrice = parseFloat(match[1]);
          if (deliveryPrice !== null && deliveryPrice !== undefined) {
            if (selected_opt_8.value.trim() === "Napoli 80" && deliveryPrice != 0) {
             deliveryPrice = 880;
            }
            else if (selected_opt_8.value.trim() === "Napoli 100" && deliveryPrice != 0) {
             deliveryPrice = 1200;
            } 
            else if (selected_opt_8.value.trim() === 'Colosso 80' & deliveryPrice != 0) {
              deliveryPrice = 1200.00;
            } 
            else if (selected_opt_8.value.trim() === 'Colosso 100' & deliveryPrice != 0) {
              deliveryPrice = 1600.00;
            } 
            else if (selected_opt_8.value.trim() === 'Colosso 120' & deliveryPrice != 0) {
              deliveryPrice = 1850.00;
            } 
          }
        }
      }
      if (selected_opt_5) {
        const text = selected_opt_5.textContent.trim();
        const match = text.match(/\$([\d,]+(?:\.\d+)?)/);
        // extract number from string (e.g. "$1200")

        if (match) {
          basePrice = parseFloat(match[1].replace(/,/g, ''));
        }
      }
      if(selected_opt_8){
        // hiddenInput_8.value = selected_opt_8.value;
        let deliveryPrice_text = 0;
        if (selected_opt_8.value.trim() === "Napoli 80") {
          deliveryPrice_text = 880.00;
        } 
        else if (selected_opt_8.value.trim() === 'Napoli 100') {
          deliveryPrice_text = 1200.00;
        }
        else if (selected_opt_8.value.trim() === 'Colosso 80') {
          deliveryPrice_text = 1200.00;
        } 
        else if (selected_opt_8.value.trim() === 'Colosso 100') {
          deliveryPrice_text = 1600.00;
        } 
        else if (selected_opt_8.value.trim() === 'Colosso 120') {
          deliveryPrice_text = 1850.00;
        } 
        console.log(deliveryPrice_text);
        const formattedPrice_delivery = deliveryPrice_text.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });

        // Update radios safely
        document.querySelectorAll('input[name="Delivery"]').forEach(radio => {
          if (radio.value.includes('Shipping (contiguous U.S.)')) {
            
            const formattedPrice_delivery = deliveryPrice_text.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD'
            });

            const newText = `Shipping (contiguous U.S.) — ${formattedPrice_delivery}`;

            // Update input value (for form submission)
            radio.value = newText;

            // Update label text (for UI)
            const label = document.querySelector(`label[for="${radio.id}"]`);
            if (label) {
              label.textContent = newText;
            }
          }
        });
      }

      let stand_price = 0;
      let chimney_price = 0;
      let stand_type = selected_opt_2.value;
      let chimney_type = selected_opt_3.value;
      let variantId = 0;
      // NAPOLI 80 RED GLOSS
      if (selected_opt_8.value.trim() === "Napoli 80"){
        basePrice = 12900;
      }
      if (stand_type === "Black Heavy Duty Stand" && selected_opt_8.value.trim() === "Napoli 80" ) {
        stand_price = 1900;
      }
      if (chimney_type === "Yes We Need the Chimney" && selected_opt_8.value.trim() === "Napoli 80" ) {
        chimney_price = 670;
      }
      // NAPOLI 80 RED GLOSS 
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827884715; }); 
      } 
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827917483; }); 
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827950251 ; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827983019; }); 
      } 

      // NAPOLI 80 LAGOON 
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827491499; }); 
      } 
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827524267; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827557035 ; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827589803; }); 
      }

      // NAPOLI 80 CARDINAL 
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827622571; }); 
      } 
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827655339; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827688107 ; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374827720875; }); 
      }

      // NAPOLI 80 DOVE GRAY 
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374828146859; }); 
      } 
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374828179627; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374828212395 ; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374828245163; }); 
      }

      // NAPOLI 80 CHARCOAL
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46370692104363; }); 
      } 
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46370692137131; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46370692169899 ; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46370692202667; }); 
      }

      // NAPOLI 80 WHITE GLOSS
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374828277931; }); 
      } 
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374828310699; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374828343467 ; }); 
      } 
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Napoli 80" )
      { 
          document.querySelectorAll('.custom-product-id').forEach(input => { input.value = 46374828376235; }); 
      }



      // NAPOLI 100 RED GLOSS
      if (selected_opt_8.value.trim() === "Napoli 100"){
        basePrice = 14900;
      }
      if (stand_type === "Black Heavy Duty Stand" && selected_opt_8.value.trim() === "Napoli 100" ) {
        stand_price = 2100;
      }
      if (chimney_type === "Yes We Need the Chimney" && selected_opt_8.value.trim() === "Napoli 100" ) {
        chimney_price = 670;
      }
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064420011;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064452779;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064485547    ;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064518315;
        });
      }


      // NAPOLI 100 LAGOON
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064026795;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064059563;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064092331;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064125099;
        });
      }

      // NAPOLI 100 CARDINAL
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064157867;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064190635;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064223403;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064256171;
        });
      }

      // NAPOLI 100 DOVE GRAY
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064682155;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064714923;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064747691;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064780459;
        });
      }


      // NAPOLI 100 CHARCOAL
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388063633579;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388063666347;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388063699115;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388063731883;
        });
      }



      // NAPOLI 100 WHITE GLOSS
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064813227;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064845995;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064878763;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need the Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Napoli 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46388064911531;
        });
      }



      // COLOSSO 80 RED GLOSS
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700267179;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700562091;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700857003;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375701151915;
        });
      }
      // COLOSSO 80 LAGOON
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700168875;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700463787;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700758699;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375701053611;
        });
      }
      // COLOSSO 80 CARDINAL
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700201643;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700496555;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700791467;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375701086379;
        });
      }

      // COLOSSO 80 DOVE GRAY
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700332715;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700627627;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700922539;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375701217451;
        });
      }


      // COLOSSO 80 CHARCOAL
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46373314199723;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46373314232491;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46373314265259;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46373314298027;
        });
      }

      // COLOSSO 80 WHITE GLOSS
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700365483;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700660395;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375700955307;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 80" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46375701250219;
        });
      }



      // COLOSSO 100 RED GLOSS
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534061227;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534388907;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534716587;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384535044267;
        });
      }
      // COLOSSO 100 LAGOON
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384533962923;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534290603;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534618283;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534945963;
        });
      }
      // COLOSSO 100 CARDINAL
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384533995691;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534323371;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534651051;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534978731;
        });
      }

      // COLOSSO 100 DOVE GRAY
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534126763;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534454443;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534782123;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384535109803;
        });
      }


      // COLOSSO 100 CHARCOAL
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384533864619;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534192299;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534519979;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534847659;
        });
      }

      // COLOSSO 100 WHITE GLOSS
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534159531;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534487211;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384534814891;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 100" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46384535142571;
        });
      }


      // COLOSSO 120 RED GLOSS
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873895595;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873928363;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873961131;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Red Gloss" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873993899;
        });
      }

      // COLOSSO 120 LAGOON
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873895595;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873928363;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873961131;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Lagoon" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873993899;
        });
      }


      // COLOSSO 120 Cardinal
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873633451;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873666219;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873698987;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Cardinal" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873731755;
        });
      }

      // COLOSSO 120 Charcoal
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873109163;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873141931;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873174699;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Charcoal" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417873207467;
        });
      }
      

      // COLOSSO 120 Dove Gray
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417874157739;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417874190507;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417874223275;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "Dove Gray" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417874256043;
        });
      }

      // COLOSSO 120 White Gloss
      if(stand_type === "No Stand Needed" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417874288811;
        });
      }
      if(stand_type === "No Stand Needed" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417874321579;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "No We Don't Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417874354347;
        });
      }
      if(stand_type === "Black Heavy Duty Stand" && chimney_type === "Yes We Need The Chimney" && selected_opt_1.value === "White Gloss" && selected_opt_8.value.trim() === "Colosso 120" ){
        document.querySelectorAll('.custom-product-id').forEach(input => {
        input.value = 46417874387115;
        });
      }

      if (selected_opt_8.value.trim() === "Colosso 100"){
        basePrice = 20200;
      }
      if (stand_type === "Black Heavy Duty Stand" && selected_opt_8.value.trim() === "Colosso 100" ) {
        stand_price = 2000;
      }
      if (chimney_type === "Yes We Need The Chimney" && selected_opt_8.value.trim() === "Colosso 100" ) {
        chimney_price = 650;
      }

      if (selected_opt_8.value.trim() === "Colosso 120"){
        basePrice = 23500;
      }
      if (stand_type === "Black Heavy Duty Stand" && selected_opt_8.value.trim() === "Colosso 120" ) {
        stand_price = 2500;
      }
      if (chimney_type === "Yes We Need The Chimney" && selected_opt_8.value.trim() === "Colosso 120" ) {
        chimney_price = 650;
      }
      console.log(basePrice);
      console.log(stand_price);
      console.log(chimney_price);


      const totalPrice = Math.round(basePrice + stand_price + chimney_price + pizzaPeelPrice + deliveryPrice);
      const formattedPrice = `$${totalPrice.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    //   hiddenInput_5.value = formattedPrice;
      updateAllCustomPrices(formattedPrice);

      

}
function updateAllCustomPrices(formattedPrice) {
  const elements = document.querySelectorAll('.custom-price');

  elements.forEach(el => {
    el.textContent = formattedPrice;
  });
}
let syncTimer = null;

function runSyncBurst() {
  let elapsed = 0;

  clearInterval(syncTimer); // IMPORTANT: prevent stacking

  syncTimer = setInterval(() => {
    syncColor();

    elapsed += 300;

    if (elapsed >= 2000) {
      clearInterval(syncTimer);
      syncTimer = null;
    }
  }, 300);
}
document.addEventListener('change', function (e) {
  if (e.target.matches('input[type="radio"]')) {
    runSyncBurst();
  }
});
document.addEventListener('DOMContentLoaded', () => {
  runSyncBurst();
});



const phoneInput = document.getElementById('Product-Quote-Form-Phone-Number');

phoneInput.addEventListener('input', (e) => {
  let x = e.target.value.replace(/\D/g, '').slice(0, 10);

  let formatted = x;
  if (x.length > 6) {
    formatted = `(${x.slice(0,3)}) ${x.slice(3,6)}-${x.slice(6)}`;
  } else if (x.length > 3) {
    formatted = `(${x.slice(0,3)}) ${x.slice(3)}`;
  }

  e.target.value = formatted;
});